<template>
    <div>
        <base-modal :isOpen="value" :title="$t('edit') | capitalize" @close="close">
            <template #body>
                <vs-row>
                    <vs-col>
                        <vs-input :label="$t('description') | capitalize" :placeholder="$t('description') | capitalize"
                            v-model="form.description" class="w-full " disabled />
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col>
                        <vs-input :label="$t('quantity') | capitalize" :placeholder="$t('quantity') | capitalize"
                            v-model="form.quantity" class="w-full " disabled />
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col>
                        <vs-input type="text" :label="$t('range')" :placeholder="$t('range')" v-model="form.range"
                            class="w-full" disabled/>
                    </vs-col>

                </vs-row>
                <vs-row class="mt-4">
                    <vs-col>
                        <vs-input type="text" :label="$t('days')" :placeholder="$t('days')" v-model="form.days"
                            class="w-full" />
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col>
                        <vs-input type="number" :label="$t('price')" :placeholder="$t('price')" v-model="form.unitPrice"
                            class="w-full" />
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col>
                        <vs-input type="text" label="Total" placeholder="Total" v-model="total" class="w-full"
                            disabled />
                    </vs-col>
                </vs-row>
                <vs-alert :active="alert" class="mt-4">
                    Please check the fields.
                </vs-alert>
            </template>
            <template #footer>
                <div class="flex gap-4">
                    <vs-button color="danger" icon="close" type="flat" @click="close">
                        {{ $t('close') | upperCase }}
                    </vs-button>
                    <vs-button color="success" icon="save" type="flat" @click="update" :disable="alert">
                        {{ $t('save') | upperCase }}
                    </vs-button>
                </div>

            </template>
        </base-modal>
    </div>

</template>

<script setup>
import { ref, watch, computed, getCurrentInstance } from 'vue'
import BaseModal from '@/views/app/components/BaseModal.vue'


const props = defineProps({
    value: { type: Boolean, default: false },
    title: { type: String, default: 'Title' },
    item: { type: Object, default: () => ({ id: '', description: '', range: '', rangeId: null, quantity: '', unit_price: '' }) }
})

const emit = defineEmits(['update', 'input'])

const { proxy } = getCurrentInstance()
const form = ref({
    description: '',
    range: '',
    rangeId: null,
    quantity: '',
    unitPrice: '',
    days: '',
    aging: '',
})

const total = computed(() => {
  const val = form.value.unitPrice * form.value.quantity * form.value.days
  return val === 0 ? "0" : val.toFixed(2)
})

const alert = computed(() => {
  const f = form.value

  const isInvalid = (val) =>
    val === ''  ||
    val === null ||
    val === undefined ||
    isNaN(val) ||
    Number(val) < 0

  return (
    isInvalid(f.unitPrice) ||
    isInvalid(f.quantity) ||
    isInvalid(f.days)
  )
})

watch(() => props.value, (newValue) => {
    if (newValue) {
        resetForm()
        form.value.id = props.item.id
        form.value.description = props.item.description
        form.value.range = props.item.range
        form.value.rangeId = props.item.range_id
        form.value.quantity = props.item.quantity
        form.value.unitPrice = props.item.unit_price
        form.value.aging = props.item.aging
        form.value.days = props.item.days
    }
})



const resetForm = () => {
    form.value.id = ''
    form.value.description = ''
    form.value.range = ''
    form.value.rangeId = null
    form.value.quantity = ''
    form.value.unitPrice = ''
    form.value.days = ''
    form.value.aging = ''
}


const close = () => {
    emit('input', false)
}

const update = () => {
    emit('update', { ...form.value,total:total.value })
}

</script>

<style></style>